import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { RepasseTable } from '../components/repasse/RepasseTable';
import { RepasseFormModal } from '../components/modals/RepasseFormModal';

const RepassesPage: React.FC = () => {
  const [selectedRepasse, setSelectedRepasse] = useState<any>(undefined);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreateNew = () => {
    setSelectedRepasse(undefined);
    setIsEditing(false);
    setModalOpen(true);
  };

  const handleEdit = (repasse: any) => {
    setSelectedRepasse(repasse);
    setIsEditing(true);
    setModalOpen(true);
  };

  const handleView = (repasse: any) => {
    setSelectedRepasse(repasse);
    setIsEditing(false);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setSelectedRepasse(undefined);
    setIsEditing(false);
    setRefreshKey(k => k + 1);
  };

  const handleCancel = () => {
    setModalOpen(false);
    setSelectedRepasse(undefined);
    setIsEditing(false);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-6 gap-3">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-semibold" style={{ color: '#3d2b56' }}>
                Gestão de Repasses
              </h1>
              <p className="text-xs mt-1" style={{ color: '#9E9E9E' }}>
                Gerencie os repasses do sistema
              </p>
            </div>
            
            <button
              onClick={handleCreateNew}
              className="px-3 py-1.5 text-xs font-medium text-white rounded-md hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 transition-opacity"
              style={{ backgroundColor: '#7A61B2' }}
            >
              + Novo Repasse
            </button>
          </div>

          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
            <RepasseTable
              onEdit={handleEdit}
              onView={handleView}
              refreshKey={refreshKey}
              onDeleted={() => setRefreshKey(k => k + 1)}
            />
          </div>
        </div>
        
        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>

      {/* Modal de Formulário */}
      {modalOpen && (
        <RepasseFormModal
          repasse={selectedRepasse}
          isOpen={modalOpen}
          isEditing={isEditing}
          onClose={handleCancel}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  );
};

export default RepassesPage;
